import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formulario-auth',
  templateUrl: './formulario-auth.component.html',
  styleUrls: ['./formulario-auth.component.css']
})
export class FormularioAuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
